import React from "react";
import { getSalesHeader, lmtdCheck } from "../../../../utils/common/index";
import CustomCard from "../../../../components/customCard/index";
import Spinner from "../../../../components/presentationals/Spinner";
import Error from "../../../../components/Error/index";

const SimBillingTabsView = ({
  timestamp,
  simBillingObj,
  fetchCsvData,
  url,
  partnerRT,
  tileName,
  csvEndPointUrl,
  csvName,
  isCsvActive,
  index,
  headerSelectedDateFrom,
  headerSelectedDateTo,
  actCsvLoading,
  section,
  moduleName,
}) => {
  let tableContainedData = {};
  if (url === "/activation-sim-billing-primary") {
    tableContainedData =
      simBillingObj?.simBillingData?.simBillingPrimary &&
      simBillingObj?.simBillingData?.simBillingPrimary?.data;
  } else if (url === "/activation-sim-billing-secondary") {
    tableContainedData =
      simBillingObj?.simBillingData?.simBillingSecondary &&
      simBillingObj?.simBillingData?.simBillingSecondary?.data;
  } else if (url === "/activation-sim-billing-tertiary") {
    tableContainedData =
      simBillingObj?.simBillingData?.simBillingTertiary &&
      simBillingObj?.simBillingData?.simBillingTertiary?.data;
  }

  // const endpointData = simBillingObj && simBillingObj.simBillingData;
  // const [downloadCsv, setDownloadCsv] = useState(false);
  // const tableContainedData = endpointData && endpointData[url] && endpointData[url][0];

  return (
    <>
      {partnerRT === "ZDMT" && tileName.split(" ")[0] === "Sell" ? (
        <>
          <CustomCard
            cardTitle={tileName + getSalesHeader(tileName)}
            tileName="SIM Billed (Count)"
            lmtd={
              lmtdCheck(headerSelectedDateFrom, headerSelectedDateTo) ? "0" : ""
            }
            value={0}
            gradient={index + 1}
            dashboardName={moduleName}
            viewName={section}
          />
        </>
      ) : (
        <>
          {
            //if it is still loading and there is no error, show spinner
            simBillingObj?.loading ? (
              <div className="col-md-4">
                <Spinner />
              </div>
            ) : //else if there is no error and data is available, show data
            tableContainedData &&
              Object.entries(tableContainedData).length > 0 ? (
              <>
                <CustomCard
                  cardTitle={tileName + getSalesHeader(tileName)}
                  tileName="SIM Billed (Count)"
                  lmtd={
                    lmtdCheck(headerSelectedDateFrom, headerSelectedDateTo)
                      ? tableContainedData?.p_lmtd_qty
                      : ""
                  }
                  value={tableContainedData?.p_mtd_qty}
                  csv={csvEndPointUrl}
                  loading={actCsvLoading}
                  csvName={csvName}
                  csvDownload={isCsvActive === "Y" ? fetchCsvData : ""}
                  gradient={index + 1}
                  timestamp={timestamp && timestamp[0]}
                  dashboardName={moduleName}
                  viewName={section}
                />
              </>
            ) : (
              //else show error
              <Error
                error={
                  simBillingObj.error &&
                  simBillingObj.error[url] &&
                  simBillingObj.error[url][0]
                }
              />
            )
          }
        </>
      )}
    </>
  );
};

export default SimBillingTabsView;
